import React, { useEffect } from 'react';
import { headers, baseUrl } from './common/credentials';


const port = "10003";
  

  export const getporequirementlistFromServer = () => {
    let url = baseUrl + port + "/po_process/user_prf_list/";
    return ([headers, url]); 
  }

  export const getporequirementbyidFromServer = () => {
    let url = baseUrl + port + "/po_process/user_prf_input_fields/";
    return ([headers, url]); 
  }

  export const getporequirementuserdetals = () => {
    let url = baseUrl + port + '/po_process/user_details/';
    return ([headers, url]); 
  }
  